"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomSignupForms = void 0;
var tslib_1 = require("tslib");
var merge_1 = tslib_1.__importDefault(require("lodash/merge"));
var base_service_1 = require("../base-service");
/**
 * Helper which fetches JSON, follows 'include':'url' and merges them into a single response
 * @param api fully-instantiated api instance
 * @param url {string} full url of config to fetch
 */
var fetchConfig = function (api, url) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var res, include, res2;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.get(url)];
            case 1:
                res = _a.sent();
                include = res && res.data && res.data.include;
                if (!include) return [3 /*break*/, 3];
                return [4 /*yield*/, fetchConfig(api, "".concat(url, "/../").concat(include))];
            case 2:
                res2 = _a.sent();
                res.data = (0, merge_1.default)(res2.data, res.data);
                _a.label = 3;
            case 3: return [2 /*return*/, res];
        }
    });
}); };
/**
 * Extracted hardcoded values for the custom sign up forms for various orgs.
 * This is the first step having this in a remote service.
 */
var CustomSignupForms = /** @class */ (function (_super) {
    tslib_1.__extends(CustomSignupForms, _super);
    // non-authenticated endpoint doesn't need a token
    function CustomSignupForms(url) {
        var _this = _super.call(this, '', url) || this;
        /**
         * Get the custom signup form content for a specific groupid and language.
         *
         * @param groupId the group ID to fetch the custom signup form content for.
         * @param language the language o the content requested.
         */
        _this.getFormContent = function (options) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var groupId, orgId, language, sanitizedinput, url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        groupId = options.groupId, orgId = options.orgId, language = options.language;
                        if (!groupId && !orgId) {
                            throw new Error('Missing option: groupId or orgId required');
                        }
                        if (!!groupId && !!orgId) {
                            throw new Error('Invalid options: both orgId and groupId defined');
                        }
                        if (!language) {
                            throw new Error('Missing option: language');
                        }
                        if (groupId) {
                            sanitizedinput = groupId.toLowerCase().replace(/\s+/g, '');
                            url = this.buildGetCustomFormContentForGroupId(sanitizedinput, language);
                        }
                        else {
                            sanitizedinput = orgId.toLowerCase().trim();
                            url = this.buildGetCustomFormContentForOrgId(sanitizedinput, language);
                        }
                        return [4 /*yield*/, fetchConfig(this.api, url)];
                    case 1:
                        response = (_a.sent());
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        /**
         * Transform the employeeid by the logic dictated by the transformId
         *
         * @param transformId The id for which id trasnform to use.
         * @param {...string} employeeIds one or more parts of the employee id
         */
        _this.transformEmployeeId = function (transformId) {
            var employeeIds = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                employeeIds[_i - 1] = arguments[_i];
            }
            if (!transformId) {
                throw new Error('Invalid argument: missing transformId');
            }
            if (!employeeIds || !employeeIds.length) {
                throw new Error('Invalid argument: missing one or more employee ids');
            }
            employeeIds = employeeIds.map(function (id) { return id.trim(); }); // Make sure every id is trimmed
            if (employeeIds.some(function (id) { return id.length === 0; })) {
                throw new Error('Invalid argument: one or more employee ids are empty');
            }
            var transformedId;
            switch (transformId) {
                case 'gwl':
                    transformedId =
                        _this.padId(employeeIds[0], 6, '0') +
                            ' ' +
                            _this.padId(employeeIds[1], 10, '0');
                    break;
                case 'sunlife':
                    transformedId =
                        _this.padId(employeeIds[0], 6, '0') +
                            ' ' +
                            _this.padId(employeeIds[1], 11, '0');
                    break;
                default:
                    transformedId = employeeIds.join('');
                    break;
            }
            transformedId = transformedId.toLowerCase(); // Employee IDs are stored in lower case on backend
            return transformedId;
        };
        _this.buildGetCustomFormContentForOrgId = function (orgId, language) { return "/".concat(language, "/org/").concat(orgId, ".json"); };
        _this.buildGetCustomFormContentForGroupId = function (groupId, language) { return "/".concat(language, "/group/").concat(groupId, ".json"); };
        return _this;
    }
    CustomSignupForms.prototype.padId = function (id, length, char) {
        var str = String(id);
        while (str.length < length)
            str = char + str;
        return str;
    };
    return CustomSignupForms;
}(base_service_1.BaseService));
exports.CustomSignupForms = CustomSignupForms;
